globalThis.tabHelper = {
  addTab: function(buttonsToClick, tabToShow)
  {

    const inActiveClasses = ["text-tinted-gray-400", "border-tinted-gray-200", "hover:border-tinted-gray-400", "hover:text-tinted-gray-500", "active:border-indigo-400", "active:text-indigo-500"];
    const activeClasses = ["border-indigo-400", "text-indigo-500"];

    buttonsToClick.forEach(tabButton =>
    {
      tabButton.addEventListener("click", function(event)
      {
        document.querySelectorAll("div[data-cst-type=tab]").forEach(tab =>
        {
          tab.style.display = "none";
        });
        tabToShow.style.display = "block";
        let selectedName = event.currentTarget.getAttribute("name");
        document.querySelectorAll("button[data-cst-type=tab]").forEach(tab =>
        {
          if (tab.getAttribute("name") === selectedName)
          {
            tab.classList.remove(...inActiveClasses);
            tab.classList.add(...activeClasses);
          }
          else
          {
            tab.classList.add(...inActiveClasses);
            tab.classList.remove(...activeClasses);
          }
        });
      });
    });
  }
};